var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3Ef690E4499894Ed34577C83Fdae7786(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Samoajat ON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Samoajat-ON",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#33652E",
    fillRule: "nonzero",
    cx: 500,
    cy: 500,
    r: 490
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.62,598.109 L438.455487,724.551506 L499.601806,778.054536 L560.748125,724.551506 L513.583,598.109 L555.939,598.109 L646.879943,649.409273 L679.601806,616.68741 L702.229223,639.314827 L652.323669,689.220381 L562.908067,638.780811 L598.455487,734.078148 L499.601806,820.575119 L400.748125,734.078148 L436.295544,638.780811 L346.879943,689.220381 L296.974389,639.314827 L319.601806,616.68741 L352.323669,649.409273 L443.264,598.109 L485.62,598.109 Z M599.601806,524.109135 L599.601806,568.109135 L400.601806,568.109135 L400.601806,524.109135 L599.601806,524.109135 Z M499.601806,145 L607.139409,300.332093 L563.91575,444.410955 L670.901741,350.700597 L792.201125,484.736417 L768.474524,506.208454 L668.30187,395.517672 L555.742,494.109 L515.597,494.109 L572.064203,305.886176 L499.601806,201.21827 L427.139409,305.886176 L483.606,494.109 L443.46,494.109 L330.875042,395.494285 L230.678082,505.710941 L207,484.185411 L328.32857,350.723984 L435.287861,444.410955 L392.064203,300.332093 L499.601806,145 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Ef690E4499894Ed34577C83Fdae7786);
export default __webpack_public_path__ + "static/media/3ef690e4499894ed34577c83fdae7786.d2caf7bb2910003c00476cef9f996f14.svg";
export { ForwardRef as ReactComponent };